<script>
import CarResource from '@/resources/car'

export default {
    name: 'ListCars',
    computed: {
        items() {
            return this.carResources.map((resource) => {
                return {
                    car: resource.attributes.name
                }
            })
        }
    },
    data() {
        return {
            loading: true,
            carResources: []
        }
    },
    methods: {},
    async beforeMount() {
        this.carResources = await CarResource.all()
        this.loading = false
    }
}
</script>

<template>
    <div>
        <b-table :items="items"></b-table>
    </div>
</template>